import type { FamilyAdditionalInfoType, IFamily, IFamilyValueItem } from '../../../../pages/common';

export function getTreatmentPlanV3FamilyAdditionalInfoArray(
  family: IFamily,
  type: FamilyAdditionalInfoType,
): IFamilyValueItem[] {
  if (type === 'MATERNAL_MEDICAL_HISTORY') return family.maternal_medical_history;
  if (type === 'PATERNAL_MEDICAL_HISTORY') return family.paternal_medical_history;
  return family.community_support;
}

export function setTreatmentPlanV3FamilyAdditionalInfoArray(
  family: IFamily,
  type: FamilyAdditionalInfoType,
  next: IFamilyValueItem[],
) {
  if (type === 'MATERNAL_MEDICAL_HISTORY') {
    family.maternal_medical_history = next;
    return;
  }
  if (type === 'PATERNAL_MEDICAL_HISTORY') {
    family.paternal_medical_history = next;
    return;
  }
  family.community_support = next;
}
